import { createFileRoute } from '@tanstack/react-router';

import { PortfolioPage } from '@/features/profiles/portfolio-page';

export const Route = createFileRoute('/_app/org/$orgId/portfolio')({ component: OrgRoute });

function OrgRoute() {
  const { orgId } = Route.useParams();
  return <PortfolioPage orgId={orgId} />;
}
